import { createAction } from 'redux-actions';
import { ProductListQuery } from './ProductListState';

export const updateQuery = createAction(
    'PRODUCT_LIST.UPDATE_QUERY',
    (query: ProductListQuery) => ({ query })
);
